
import { Star } from "lucide-react";

interface ContractorRatingProps {
  rating: number;
  reviewCount: number;
}

export const ContractorRating = ({ rating, reviewCount }: ContractorRatingProps) => {
  // Ensure rating is a number and within range
  const safeRating = typeof rating === 'number' && !isNaN(rating) ? Math.min(Math.max(rating, 0), 5) : 0;
  const displayRating = safeRating.toFixed(1);
  
  // Ensure review count is a number
  const safeReviewCount = typeof reviewCount === 'number' && !isNaN(reviewCount) ? reviewCount : 0;
  
  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center">
        <Star className="h-5 w-5 fill-yellow-400 text-yellow-400" />
        <span className="font-medium text-lg ml-1">{displayRating}</span>
      </div>
      <span className="text-muted-foreground">
        ({safeReviewCount} {safeReviewCount === 1 ? 'review' : 'reviews'})
      </span>
    </div>
  );
};
